import React, { useState, useEffect, useRef } from 'react';
import EditorJS from '@editorjs/editorjs';
import editorTools, { updateLinkEvents } from './EditorTools';
import { convertDataType } from './EditorTools';

const EditorViewer = (props) => {
    const editorInstance = useRef(null);
    const editorContainer = useRef(null);

    useEffect(() => {  
        if(props.docId === "") return;
        if (editorInstance.current) {
            editorInstance.current.destroy();
            editorInstance.current = null;
        }
        if(editorContainer.current) {
            const editor = new EditorJS({
                readOnly: true,
                holder: editorContainer.current,
                minHeight: !props.folderName ? 0 : 80,
                tools: editorTools(props.folderName, props.docId),
                onReady: async () => {
                    editorInstance.current = editor
                    if(props.editorData.data) {
                        await editorInstance.current.render(convertDataType(props.editorData.data, props.folderName, props.docId));
                    }
                    else {
                        await editorInstance.current.clear();
                    }
                    updateLinkEvents(true);
                }
            });
        }

        return () => {
            if (editorInstance.current) {
                editorInstance.current.destroy();
                editorInstance.current = null;
            }
        }
    }, [props.docId]);
    
    useEffect(() => {
        if(editorInstance.current) {
            if(props.editorData.data) {
                editorInstance.current.render(convertDataType(props.editorData.data));
            }
            else {
                editorInstance.current.clear();
            }
        }
    }, [props.editorData]);

    return (
        <div id="editorjs" className='editor' ref={editorContainer}></div>
    )
}
export default EditorViewer;